// apps/web/src/components/primitives/tepi.ts
/**
 * Along one axis of a scroll box: whether content lies hidden before what shows (`awal`: it has
 * been scrolled) and past it (`akhir`: more lies that way; gone at the end of the scroll), from
 * the scroll position, the box's own size and its content's. A pixel of slack either way, for a
 * position a zoomed screen reports in fractions. The rule behind every edge fade (tepiGeser).
 * Pure and DOM-free: the node tests import it.
 */
export function tepiTersembunyi(
  posisi: number,
  tampak: number,
  isi: number,
): { awal: boolean; akhir: boolean } {
  return { awal: posisi > 1, akhir: posisi + tampak < isi - 1 }
}
